import {Component, Input} from '@angular/core';

/**
 * navItem "Basisdaten" of the Provisionszeile OBC, widget alias `cp.provisionContract.baseData`.
 *
 * The identity of the time slice: the `cm.Contract` it belongs to, the Provisionstyp, the event
 * that produced it, and the period. `startDate` is the third part of the business key and the only
 * period bound a user maintains; `endDate` is read-only and system-populated by the START of the
 * next event time slice, which is why both are shown together — a slice is only readable against
 * its successor.
 *
 * `eligibilityOverwrite` sits here rather than in "Berechnung" on purpose: it is an INPUT, the
 * manual hard include/exclude, and NULL means "no overwrite, the configuration decides". The
 * computed `eligibility` is the counterpart and belongs to the calculation pane.
 *
 * `triggeringContractPriceId` is the technical origin (the `cm.ContractPrice` row that triggered
 * the event) and is shown last, as a lookup handle for support.
 *
 * FORM MECHANISM: metadata driven, no manual Angular form — see
 * {@link CpProvisionObjectDataComponent}.
 */
@Component({
    selector: 'cp-provision-contract-base-data',
    templateUrl: './cp-provision-contract-base-data.component.html',
    styleUrls: ['./cp-provision-contract-base-data.component.scss'],
    standalone: false
})
export class CpProvisionContractBaseDataComponent {

    @Input() provisionContractId: number;

    /** Fields per row — the side view passes 1. */
    @Input() columns: number = 2;

    /** Visible fields; FK fields by their `...DtoName` variant. */
    readonly fields: string[] = [
        'contractDtoName',
        'provisionTypeDtoName',
        'provisionTypeContractEventDtoName',
        'startDate',
        'endDate',
        'applicationDate',
        'eligibilityOverwrite',
        'triggeringContractPriceId'
    ];

}
